import FormInitialize from "./Initialize/FormInitialize"
import BasicInitialize from './Initialize/BasicInitialize'
import * as bootstrap from 'bootstrap'
import * as jQuery from 'jquery'

